export const HeroHeading = () => {
  return (
    <div>
      <div class="text-center mb-4 lg:mb-6">
        <div class="inline-block border border-black/10 dark:border-black/50 bg-white/20 dark:bg-black/40 rounded-full px-6 py-2">
          <p class="text-xs lg:text-sm text-black dark:text-white">
            <span>Without the </span>
            <span class="font-semibold text-blue-600 dark:text-blue-400">narrative</span>
            <span class="text-black dark:text-white">, data is just noise.</span>
          </p>
        </div>
      </div>
      <h2 class="relative mt-8 mb-0 text-4xl lg:text-5xl text-center max-w-4xl mx-auto">
        <div class="mb-2 lg:mb-4 font-semibold">
          Talk to Your{" "}
          <span class="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text dark:from-blue-400 dark:via-indigo-400 dark:to-purple-400 text-transparent">
            Data
          </span>
        </div>
        <div class="text-2xl lg:text-3xl">
          <div class="block md:hidden">
            Unlock the{" "}
            <span class="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text dark:from-blue-400 dark:via-indigo-400 dark:to-purple-400 text-transparent">
              intelligence
            </span>
            <br />
            hiding in your{" "}
            <span class="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text dark:from-blue-400 dark:via-indigo-400 dark:to-purple-400 text-transparent">
              un|structured
            </span>{" "}
            data
          </div>
          <div class="hidden md:block">
            Unlock the{" "}
            <span class="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text dark:from-blue-400 dark:via-indigo-400 dark:to-purple-400 text-transparent">
              intelligence
            </span>{" "}
            hiding in your{" "}
            <span class="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text dark:from-blue-400 dark:via-indigo-400 dark:to-purple-400 text-transparent">
              un|structured
            </span>{" "}
            data
          </div>
        </div>
      </h2>
    </div>
  );
};
